import React from 'react'

import { Content, Heading } from '../../components/Typography'
import SectionLayout from '../../layouts/SectionLayout/SectionLayout'
// import { ContentParser, hasNulls } from "../../utils/helpers";
import { contentRow } from './BlogContent.module.css'
// import { CtaButton } from "../../components";

const BlogContent = ({ slice }) => {
  const { content, heading } = slice
  // const blogContent = ContentParser(slice, 'contentgroup').filter(res => !hasNulls(Object.values(res)));
  // let ctaButton = blogcontentcta;
  // typeof blogcontentcta === 'string' && (ctaButton = JSON.parse(blogcontentcta));
  return (
    <SectionLayout>
      <div className={contentRow}>
        <Heading>{heading}</Heading>
        <Content renderContent={content} />
      </div>
      {/* {blogcontentcta && <CtaButton {...ctaButton}/>}    */}
    </SectionLayout>
  )
}

export default BlogContent
